module.exports = __webpack_public_path__ + "static/img/filter.aeba16b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/filter.png
// module id = VyPc
// module chunks = 1